import {myLinks} from "@/lib/routes/myLinks";
import NextLink from "next/link";
import {useMemo} from "react";

export const Link = ({children, noStyle, route, query = {}, href, dynamic,...props}) => {

    const getUrl = useMemo(()=>{
        let url = '#'

        if (href){
            url = href
        }

        if (route){
            url = myLinks.getUlr(route, query)
        }

        return dynamic ? `${url}?dynamic=${Math.random()}` : url
    }, [])

    return (
        <>
            <NextLink
                href={getUrl}
                {...props}
            >
                {children}
            </NextLink>
        </>
    );
}